import type { SVGProps } from "react";
export interface CurtainIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CurtainIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CurtainIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M6.617 12.029c2.423 2.49 3.408 5.153 3.5 8.439l-.004.171a1.614 1.614 0 0 1-1.448 1.477l-.165.009h-5A1.625 1.625 0 0 1 1.875 20.5V14a1.125 1.125 0 0 1 2.25 0v5.875h3.709c-.18-2.457-.996-4.391-2.83-6.276zm-1.591-.02a1.125 1.125 0 0 1 1.59.02l-1.612 1.57a1.125 1.125 0 0 1 .022-1.59M22.125 20.5c0 .841-.64 1.534-1.459 1.617l-.166.008h-5c-.89 0-1.644-.728-1.618-1.657l.028-.61c.194-3.009 1.201-5.495 3.473-7.83a1.125 1.125 0 0 1 1.613 1.571c-1.834 1.885-2.65 3.82-2.83 6.276h3.709V14a1.125 1.125 0 0 1 2.25 0z"
      />
      <path
        fill={color}
        d="m22 1.875.115.006a1.125 1.125 0 0 1 .01 2.235V14a1.128 1.128 0 0 1-1.398 1.092c-4.118-1.03-7.304-4.36-8.728-8.646-1.424 4.285-4.608 7.616-8.726 8.646A1.125 1.125 0 0 1 1.875 14V4.117A1.125 1.125 0 0 1 2 1.875zM4.125 10.024q.042-.096.081-.192a20 20 0 0 0 .662-1.956q.022-.077.032-.117l.008-.026.001-.006.032-.11a1.126 1.126 0 0 1 2.15.656v.006l-.004.012-.01.04-.04.145a22 22 0 0 1-.743 2.193q-.122.304-.267.63c1.946-1.486 3.432-3.773 4.123-6.54l.159-.634H4.125zm9.724-5.265.104.388c.73 2.593 2.164 4.736 4.018 6.153a22 22 0 0 1-1.01-2.824l-.037-.145-.01-.04-.003-.012-.002-.004v-.002l-.023-.114a1.126 1.126 0 0 1 2.172-.542l.034.11.001.006.008.026.03.117a20 20 0 0 0 .664 1.956l.08.193v-5.9h-6.184z"
      />
    </svg>
  );
}
